import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { ValidationService } from '../../shared/providers/validation.service'
import { AuthenticationService } from '../../shared/auth/authentication.service'
import { PropertyListingService } from '../../shared/providers/property-listing.service'
import { LoaderService } from '../../shared/providers/loader.service'
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UserManagerService } from '../../shared/providers/user-manager.service'
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';

enum Tabs {
  MarketSnapShot = 1,
  PortfolioAnalysis = 2,
  Files = 3,
  MasterContactList = 4,
  AssetManagement = 5,
  Preferences = 6

}
interface IPortfolioData {
  Name: string;
  Id: number;
  UserGuid: string;
}

@Component({
  selector: 'app-market-snapshot',
  templateUrl: './market-snapshot.component.html',
  styleUrls: ['./market-snapshot.component.css']
})
export class MarketSnapshotComponent implements OnInit,OnDestroy {
  currentMenu = '';
  constructor(private router: Router, private activatedRoute: ActivatedRoute, private UserManager: UserManagerService, public Validation: ValidationService, private modalService: BsModalService, private propertyListing: PropertyListingService, public authentication: AuthenticationService, private Loader: LoaderService) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['opentab'] !== undefined && params['opentab'] !== null && params['opentab'] !== '') {
        this.currentTab = params['opentab'];
      }
      if (params['UserGuid'] !== undefined && params['UserGuid'] !== null && params['UserGuid'] !== '') {
        this.principalUserGuid = params['UserGuid'];
      }
      if (params['FromUrl'] !== undefined && params['FromUrl'] !== null && params['FromUrl'] !== '') {
        this.IsFrom =1;
        this.FromUrl = params['FromUrl'];
      }
    });
  }
  modalRefBOV: BsModalRef;
  private _subscriptions: Subscription[] = [];
  user: any;
  tabs = Tabs;
  currentTab = Tabs.MarketSnapShot;
  IsBroker = false;
  currentUser: any;
  principalUserGuid: string = '';
  IsStandardUser = false;
  UserPortfolio: IPortfolioData[] = [];
  portfolioData = "'s Portfolio";
  selectedPortfolio: number = 0;
  selectedPortfolioName: string = 'My Portfolio'
  IsmyPortfolio = true;
  myportfolio: string;
  hasAccess: number = 0;
  FromUrl: string = '';
  IsFrom: number = 0;
  ngOnInit() {
    this.Loader.display(true);
    this.user = this.authentication.user;
    if (this.authentication.Admin() || this.authentication.SuperAdmin()) {
      this.Loader.display(false);
      this.hasAccess = 1;
    }
    else {
      this.CheckMyPortfolioAccess();
    }

    this.principalUserGuid = this.principalUserGuid != '' ? this.principalUserGuid : '0000'
    if (this.authentication.Principal() || this.authentication.Principal1031() || this.authentication.Seller()) {
      this.getOtherUserPortfolio();
    }
    this.IsStandardUser = true;
  }

  ngOnDestroy() {
    this._subscriptions.forEach(sub => sub.unsubscribe());
    if (localStorage.getItem('MyPortfolioAccessStatus') != null) {
      localStorage.removeItem('MyPortfolioAccessStatus');
    }
  }

  onTabClick(tab) {
    this.currentTab = tab;
    let url = this.router.url.split('?')[0];
    this.myportfolio = this.selectedPortfolioName;
    if (localStorage.getItem('currentFileRefreshTab') != undefined && localStorage.getItem('currentFileRefreshTab') != null) {
      localStorage.removeItem('currentFileRefreshTab');
    }
    url = this.Validation.updateQueryStringParameter(this.router.url, 'opentab', tab)
    this.router.navigateByUrl(url);
  }

  getOtherUserPortfolio() {
    this.propertyListing.GetOtherUserPortfolio(this.user.Id, this.principalUserGuid).subscribe(response => {
      this.UserPortfolio = response;
      if (this.principalUserGuid != null && this.principalUserGuid != '') {
        let currentPortfolio = this.UserPortfolio.find(x => x.UserGuid == this.principalUserGuid);
        if (currentPortfolio != null) {
          this.selectedPortfolio = currentPortfolio.Id;
          localStorage.setItem('PortfolioName', currentPortfolio.Name);
          this.selectedPortfolioName = this.user.Id == currentPortfolio.Id ? 'My Portfolio' : currentPortfolio.Name;
          this.IsmyPortfolio = this.selectedPortfolio == this.user.Id ? true : false;
        }
      }
      else {
        let currentPortfolio = this.UserPortfolio.find(x => x.Id == this.user.Id);
        if (currentPortfolio != null) {
          this.selectedPortfolioName = this.user.Id == currentPortfolio.Id ? 'My Portfolio' : currentPortfolio.Name;
          this.selectedPortfolio = currentPortfolio.Id;
          localStorage.setItem('PortfolioName', this.selectedPortfolioName);
          this.IsmyPortfolio = this.selectedPortfolio == this.user.Id ? true : false;
        }
      }
    });
  }

  bindData() {
    if (this.selectedPortfolio != null) {
      this.IsFrom = 0;
      this.myportfolio = this.selectedPortfolioName;
      let selectedId = this.selectedPortfolio;
      let currentPortfolio = this.UserPortfolio.find(x => x.Id == selectedId);
      if (currentPortfolio != null) {
        this.principalUserGuid = currentPortfolio.UserGuid;
        this.selectedPortfolio = currentPortfolio.Id;
        localStorage.setItem('PortfolioName', currentPortfolio.Name);
        this.selectedPortfolioName = this.user.Id == currentPortfolio.Id ? 'My Portfolio' : currentPortfolio.Name;
        this.IsmyPortfolio = (currentPortfolio.Id == this.user.Id) ? true : false;
      }
      else {
        this.IsmyPortfolio = true;
      }
      let currentTabVal = (this.currentTab != null && this.currentTab > 0) ? this.currentTab : 1;
      if (!this.authentication.Admin() || this.authentication.SuperAdmin()) {
        currentTabVal = !this.IsmyPortfolio && currentTabVal == 6 ? 1 : currentTabVal;
      }
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['/market-snapshot'], { queryParams: { UserGuid: this.principalUserGuid, opentab: currentTabVal } }));
    }
  }

  onBreadCrumbClick(SourceType: number = 0) {
    if (SourceType == 1 && this.FromUrl != '' && this.FromUrl != null) {
      this.router.navigateByUrl(this.FromUrl);
    }
    else {
      this.router.navigate(['/view-portfolio']);
    }
  }

  onHomeBreadCrumbClick() {
    this.router.navigateByUrl('/principal-dashboard');
  }

  CheckMyPortfolioAccess() {
    if (this.user != null && this.user.Id > 0) {
      let accessResponse = 0;
      if (localStorage.getItem('MyPortfolioAccessStatus') != null && localStorage.getItem('MyPortfolioAccessStatus') != '') {
        accessResponse = JSON.parse(localStorage.getItem('MyPortfolioAccessStatus'));
      }
      if (accessResponse == 0) {
        this.propertyListing.CheckMyportfolioAccess(this.user.Id).subscribe(res => {
          let response = res as boolean
          this.hasAccess = response ? 1 : 2;
          localStorage.setItem('MyPortfolioAccessStatus', JSON.stringify(this.hasAccess));
          this.Loader.display(false);
        });
      }
      else {
        this.hasAccess = accessResponse ? 1 : 2;
        this.Loader.display(false);
      }
    }
  }
}
